import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { utils } from "@alife/cone-arms-core";
var checkWin = utils.checkWin, supportedEntryType = utils.supportedEntryType;
export var getXhrHeaderByName = function(xhr, name) {
    if (xhr && typeof xhr.getResponseHeader === "function" && typeof xhr.getAllResponseHeaders === "function") {
        var allResponseHeader = xhr.getAllResponseHeaders() && xhr.getAllResponseHeaders().toLowerCase() || "";
        if (allResponseHeader.indexOf(name) > -1) {
            return xhr.getResponseHeader(name);
        }
    }
    return "";
};
/**
 * 根据自定义字段获取响应头中的traceId
 * @param method 请求方式：xhr、fetch、mtop
 * @param req 请求相关参数，对应上述为xhr，res, responseHeaders
 * @param traceIdHeaderName 自定义traceid字段名数组
 * @returns
 */ export var getTraceId = function(method, req, traceIdHeaderName) {
    try {
        var traceIdNames = [];
        // 默认取eagleeye-traceid
        var defaultTraceIdName = [
            "eagleeye-traceid",
            "x-eagleeye-id",
            "x-trace-id"
        ];
        if (traceIdHeaderName && typeof traceIdHeaderName === "string") {
            traceIdNames = [
                traceIdHeaderName
            ].concat(_to_consumable_array(defaultTraceIdName));
        } else if (Array.isArray(traceIdHeaderName)) {
            traceIdNames = _to_consumable_array(traceIdHeaderName).concat(_to_consumable_array(defaultTraceIdName));
        } else {
            traceIdNames = defaultTraceIdName;
        }
        // 去除数组中的空值
        traceIdNames = traceIdNames.filter(function(i) {
            return i && String(i).trim();
        }).map(function(i) {
            return String(i);
        });
        var traceId = "";
        if (method === "xhr" && req && typeof req.getAllResponseHeaders === "function" && typeof req.getResponseHeader === "function") {
            var allResponseHeader = req.getAllResponseHeaders() && req.getAllResponseHeaders().toLowerCase() || ""; // 返回全部头信息,string
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = traceIdNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var trace = _step.value;
                    var _allResponseHeader;
                    var ableTraceId = ((_allResponseHeader = allResponseHeader) === null || _allResponseHeader === void 0 ? void 0 : _allResponseHeader.indexOf(trace)) !== -1;
                    if (ableTraceId) {
                        var resTraceId = req.getResponseHeader(trace);
                        if (resTraceId) {
                            traceId = String(resTraceId);
                            return traceId;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else if (method === "fetch" && req.headers && typeof req.headers.get === "function") {
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = traceIdNames[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var trace1 = _step1.value;
                    var resTraceId1 = req.headers.get(trace1);
                    if (resTraceId1) {
                        traceId = String(resTraceId1);
                        return traceId;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        } else if (method === "mtop") {
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = traceIdNames[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var trace2 = _step2.value;
                    var reg = new RegExp("".concat(trace2, ":\\s*([a-z0-9]+)"));
                    var matchTraceId = req.match(reg);
                    if (matchTraceId && matchTraceId[1]) {
                        traceId = String(matchTraceId[1]);
                        return traceId;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        return traceId;
    } catch (err) {
    // ignore error
    }
    return "";
};
export var checkIgnoreUrl = function(url, ignore) {
    if (typeof ignore === "function") {
        return ignore(url);
    } else {
        return typeof ignore.some === "function" && ignore.some(function(ignoreRule) {
            if (typeof ignoreRule === "string") {
                var _url;
                return ((_url = url) === null || _url === void 0 ? void 0 : _url.indexOf(ignoreRule)) !== -1;
            } else {
                if (typeof ignoreRule === "object" && typeof ignoreRule.test === "function") {
                    return ignoreRule.test(url);
                }
                return false;
            }
        });
    }
};
export var extendLogItemWithResponse = function(logItem, res) {
    var response = res;
    if (typeof res === "string") {
        try {
            response = JSON.parse(res);
        } catch (e) {
        // ignore error
        }
    }
    if (typeof response === "object" && response && typeof logItem === "object" && logItem) {
        var newLogItem = {};
        // 如果response中有返回traceId，直接复用
        newLogItem.traceId = logItem.traceId || response.traceId;
        if (typeof response.success === "boolean") {
            newLogItem.bizSuccess = response.success;
        }
        if (response.success === false) {
            // 业务error，也全量上报
            newLogItem.sampling = 1;
            // 新的统一接口规范
            if (response.errorCode) {
                newLogItem.code = response.errorCode;
                newLogItem.msg = response.errorMsg || response.msg;
            } else if (response.error) {
                // 兼容旧的规范
                newLogItem.msg = response.error.message;
                newLogItem.code = response.error.code;
            }
            // 业务逻辑，记录response
            newLogItem.response = JSON.stringify(response);
        }
        // 上报response是否符合接口规范
        newLogItem.responseIsMatchSpecification = true;
        [
            "success",
            "errorCode",
            "errorMsg"
        ].forEach(function(key) {
            if (!(response && typeof response === "object" && key in response)) {
                newLogItem.responseIsMatchSpecification = false;
            }
        });
        Object.assign(logItem, newLogItem);
    }
};
export var parseServerTimingHeader = function() {
    var serverTimingData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ret = [];
    if (typeof serverTimingData === "string" && serverTimingData.length > 0) {
        var keyData = serverTimingData.split(",");
        keyData.forEach(function(str) {
            var arr = str.trim().split(";");
            if (arr.length > 1) {
                var keyValue = {};
                var keyName = arr[0];
                if (keyName) {
                    for(var idx = 1; idx < arr.length; idx++){
                        var tmpStr = arr[idx];
                        var keyValueStrArr = tmpStr.split("=");
                        if (keyValueStrArr.length === 2) {
                            keyValue[keyValueStrArr[0].trim()] = keyValueStrArr[1].trim().replace(/["']/g, "");
                        }
                    }
                    ret.push({
                        name: keyName,
                        duration: keyValue.dur || keyValue.duration || 0,
                        description: keyValue.desc || keyValue.description || ""
                    });
                }
            }
        });
    }
    return ret;
};
export var getFullUrl = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (typeof url === "string") {
        try {
            if (/^http/.test(url)) {
                return url;
            }
            if (url.indexOf("//") === 0) {
                return "".concat(location.protocol).concat(url);
            }
            if (url.indexOf("/") === 0) {
                return "".concat(location.protocol, "//").concat(location.host).concat(url);
            }
            return "".concat(location.href.replace(location.search, "").replace(location.hash, "")).concat(url);
        } catch (e) {
            return url;
        }
    }
    return url;
};
export var appendServerTimingToLogItem = function(logItem, serverTimingList) {
    if (Array.isArray(serverTimingList)) {
        var entry = serverTimingList.find(function(i) {
            return i && i.name === "app" && i.duration && i.duration > 0;
        });
        Object.assign(logItem, {
            serverTiming: serverTimingList,
            serverExecTime: entry ? entry.duration : 0
        });
    }
};
export var extendLogItemWithTimeZone = function(logItem) {
    if (typeof logItem === "object" && logItem) {
        var newLogItem = {};
        var dateIns = new Date();
        if (typeof newLogItem.timeZone === "undefined" && typeof dateIns.getTimezoneOffset === "function") {
            var hourOffset = 0 - Math.ceil(dateIns.getTimezoneOffset() / 60);
            newLogItem.timeZone = "UTC".concat(hourOffset > 0 ? "+" : "").concat(hourOffset);
        }
        Object.assign(logItem, newLogItem);
    }
};
export var extendRequestAndResponseSizes = function(logItem, data, res) {
    var requestSize = 0;
    var responseSize = 0;
    if (typeof TextEncoder !== "function") {
        return;
    }
    try {
        if (logItem && typeof logItem === "object") {
            var encoder = new TextEncoder();
            if (logItem.method === "GET") {
                requestSize = encoder.encode(logItem.params).length;
            } else if (data) {
                if (typeof data === "string") {
                    requestSize = encoder.encode(data).length;
                } else if (_instanceof(data, FormData)) {
                    requestSize = Array.from(data.entries()).reduce(function(size, entry) {
                        var value = entry[1];
                        return size + new Blob([
                            value
                        ]).size;
                    }, 0);
                } else if (typeof data === "object") {
                    requestSize = encoder.encode(JSON.stringify(data)).length;
                }
            }
            if (res) {
                if (typeof res === "string") {
                    responseSize = encoder.encode(res).length;
                } else if (typeof res === "object") {
                    responseSize = encoder.encode(JSON.stringify(res)).length;
                }
            }
            requestSize = Math.round(requestSize / 1024 * 100) / 100;
            responseSize = Math.round(responseSize / 1024 * 100) / 100;
            logItem.requestSize = requestSize;
            logItem.responseSize = responseSize;
        }
    } catch (error) {
        console.error("Error calculating request and response sizes:", error);
    }
};
export var initLongTaskObserver = function() {
    var totalLongTaskCount = 0;
    var entryType = "longtask";
    var startCountMap = {};
    var observerLongTask = null;
    if (checkWin() && supportedEntryType(entryType)) {
        observerLongTask = new PerformanceObserver(function(list) {
            list.getEntries().forEach(function(entry) {
                if (entry.duration > 50) {
                    totalLongTaskCount++;
                }
            });
        });
        try {
            observerLongTask.observe({
                type: entryType,
                buffered: true
            });
        } catch (e) {
        // do nothing
        }
    }
    return {
        start: function(key) {
            startCountMap[key] = totalLongTaskCount;
        },
        end: function(key) {
            if (startCountMap[key] !== undefined) {
                var count = totalLongTaskCount - startCountMap[key];
                if (count > 0) {
                    return count;
                }
            }
            return 0;
        },
        stop: function() {
            observerLongTask && observerLongTask.disconnect();
        }
    };
};
export var genRequestId = function(url) {
    var _url;
    var urlPath = typeof url === "string" ? url : ((_url = url) === null || _url === void 0 ? void 0 : _url.href) || "";
    return "".concat(urlPath, "_").concat(Date.now(), "_").concat(Math.ceil(Math.random() * 100000));
};
/**
 * 判断是否是SSE消息
 * @param res 响应
 * @returns 是否是SSE消息
 */ export var isSSEMessage = function(res) {
    var _res_headers, _res_headers1;
    var contentType = typeof ((_res_headers = res.headers) === null || _res_headers === void 0 ? void 0 : _res_headers.get) === "function" ? ((_res_headers1 = res.headers) === null || _res_headers1 === void 0 ? void 0 : _res_headers1.get("content-type")) || "" : "";
    var isText = contentType === "text/plain";
    var url = typeof res.url === "string" ? res.url : "";
    return isText && url.replace(/\?.*/, "").indexOf("/message") !== -1;
};
export var isSSEEventStream = function(res) {
    var _res_headers, _res_headers1;
    var contentType = typeof ((_res_headers = res.headers) === null || _res_headers === void 0 ? void 0 : _res_headers.get) === "function" ? ((_res_headers1 = res.headers) === null || _res_headers1 === void 0 ? void 0 : _res_headers1.get("content-type")) || "" : "";
    var isEventStream = contentType.indexOf("text/event-stream") !== -1;
    return isEventStream;
};

 //# sourceMappingURL=utils.js.map